import styles from './LiveBadge.module.scss';

const LiveBadge = () => (
  <span className={styles.liveBadge}>
    <svg className={styles.liveBadgeCircle} viewBox="0 0 20 20" width="10" height="10">
      <circle cx="10" cy="10" r="10"></circle>
    </svg>
    LIVE NOW
  </span>
);

export default LiveBadge;
